<template>
  <cus-header class="news" :text-img="require('@/assets/main/head_title_text_news.png')">
    <div class="news-body">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span
            ><i
              class="el-icon-location"
              style="color: #006cff; margin-right: 1vw"
            ></i
          ></span>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/news' }"
              >工作动态</el-breadcrumb-item
            >
          </el-breadcrumb>
        </div>
        <div class="mb-notice">
          <div class="mb-notice-body">
            <div
              class="mb-notice-cell"
              v-for="(item, index) in list"
              :key="index"
              @click="Goto('/newsDetail')"
            >
              <div class="left">
                {{ item.label }}
              </div>
              <div class="right">{{ item.date }}</div>
            </div>
          </div>
          <div class="pagination">
            <el-pagination background layout="prev, pager, next" :total="9">
            </el-pagination>
          </div>
        </div>
      </el-card>
    </div>
  </cus-header>
</template>
<script>
export default {
  data() {
    return {
      list: [
        {
          label:
            "关于进一步做好黑龙江省基础学科高水平人才培养基地建设和地方高校“101计划”试点推进及增补工作...",
          date: "2024-06-03",
        },
        {
          label:
            "黑龙江省教育厅关于组织开展首批省级基础学科高水平培养基地建设方案编制工作的通知",
          date: "2024-06-03",
        },
        {
          label: "全面推进“一〇一计划” 筑基拔尖创新人才培养",
          date: "2024-06-03",
        },
        {
          label:
            "关于开展黑龙江省基础学科和“四新” 关键领域本科教育教学改革试点工作 （地方高校“101计划”）...",
          date: "2024-06-03",
        },
        {
          label: "关于组织参加2024年大学生新文科实践创新大赛的通知",
          date: "2024-06-03",
        },
        {
          label: "关于组织参加2024年大学生新文科实践创新大赛的通知",
          date: "2024-06-03",
        },
        {
          label: "关于组织参加2024年大学生新文科实践创新大赛的通知",
          date: "2024-06-03",
        },
        {
          label: "关于组织参加2024年大学生新文科实践创新大赛的通知",
          date: "2024-06-03",
        },
        {
          label: "关于组织参加2024年大学生新文科实践创新大赛的通知",
          date: "2024-06-03",
        },
      ],
    };
  },
  mounted() {},
  computed: {},
  methods: {
    Goto(path) {
      this.$router.push(path);
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .el-card {
  background: rgba($color: #fff, $alpha: 0.3);
}
::v-deep .el-card__header {
  padding: 1vw;
  border-bottom: 0.052083vw solid #cee2f1;
  box-sizing: border-box;
}
::v-deep .el-card__body {
  padding: 0;
}
::v-deep .el-breadcrumb__item .is-link {
  color: #666666;
  font-weight: 400;
}
::v-deep .el-breadcrumb {
  font-size: 0.9vw;
  width: 10vw;
  .el-breadcrumb__separator {
    margin:0 0.3vw;
  }
}
::v-deep .el-pagination {
  padding: 0.1vw 0.52083vw;
  .btn-prev {
    min-width: 1.7vw;
    width: 1.7vw;
    height: 2.5vh;
    margin: 0 0.5vw;
    border-radius: 0.2vw;
    background: #fff;
    .el-icon {
      font-size: 0.6vw;
      height: 1vh;
    }
  }
  .btn-next {
    min-width: 1.7vw;
    width: 1.7vw;
    height: 2.5vh;
    margin: 0 0.5vw;
    border-radius: 0.2vw;
    background: #fff;
    .el-icon {
      font-size: 0.6vw;
      height: 1vh;
    }
  }
  .el-pager li {
    padding: 0 0.3vw;
    min-width: 2vw;
    width: 2vw;
    height: 2.2vh;
    margin: 0 0.5vw;
    border-radius: 0.2vw;
    font-size: 0.8vw;
    line-height: 2.2vh;
  }
}
.news {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  background-color: #edf6fa;
  position: relative;
  overflow: hidden;

  .news-body {
    z-index: 2;
    flex-grow: 1;
    padding: 2vh 20%;
    .clearfix {
      width: 15vw;
      display: flex;
      align-items: center;
    }
    .mb-notice {
      height: 100%;
      width: 100%;
      margin-right: 1.0416666666vw;
      display: flex;
      flex-direction: column;
      position: relative;
      .mb-notice-body {
        width: 100%;
        position: relative;
        z-index: 3;
        overflow-y: auto;

        .mb-notice-cell {
          height: 14.2857142%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 0 1.0416666666vw;
          border-bottom: 0.052083vw solid #ccc;
          min-height: 3.125vw;

          .left {
            position: relative;
            padding-left: 1.0416666666vw;
            margin-right: 1.0416666666vw;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            flex-grow: 1;
            width: 0;
            cursor: pointer;
          }

          .left::after {
            content: "";
            display: block;
            position: absolute;
            width: 0.4166666vw;
            height: 0.4166666vw;
            border-radius: 50%;
            background-color: #b7b7b7;
            top: 50%;
            margin-top: -0.20833333vw;
            left: 0;
          }

          .right {
            color: #666666;
          }
        }

        & .mb-notice-cell:last-child {
          border-bottom: 0 none;
        }

        .mb-notice-cell:hover .left {
          color: #006cff;
        }

        .mb-notice-cell:hover .right {
          color: #006cff;
        }

        .mb-notice-cell:hover .left::after {
          background-color: #006cff;
        }
      }
    }
    .pagination {
      height: 4vh;
      padding: 2vw;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
